import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import ZendeskHelp from '@/shared/components/ZendeskHelp';
import Button from './Button';

const messages = defineMessages({
  Ok: 'Ok',
});

class OkModal extends Component {
  static propTypes = {
    title: PropTypes.node,
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    intl: intlShape.isRequired,
    size: PropTypes.string,
    okLabel: PropTypes.node,
    disableFullScreen: PropTypes.bool,
    leftButton: PropTypes.node,
    dismissOnClickOutsideModal: PropTypes.bool,
    onHoverSave: PropTypes.func,
    zendeskArticle: PropTypes.string,
    okClassName: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    show: false,
    size: '',
    disabled: false,
    okLabel: undefined,
    disableFullScreen: false,
    dismissOnClickOutsideModal: false,
    onHoverSave: () => {},
    zendeskArticle: null,
    leftButton: undefined,
    okClassName: 'btn-inverse',
  };

  state = {
    fullScreen: false,
  };

  render() {
    const {
      title,
      show,
      onClose,
      children,
      disabled,
      intl,
      size,
      okLabel,
      okClassName,
      disableFullScreen,
      leftButton,
      onHoverSave,
      dismissOnClickOutsideModal,
      zendeskArticle,
    } = this.props;
    const { fullScreen } = this.state;

    return (
      <Modal
        enforceFocus={false} // set this to false so other modals can be shown on top of this one and be editable
        backdrop={dismissOnClickOutsideModal ? true : 'static'}
        show={show}
        onHide={onClose}
        dialogClassName={classNames({
          'modal-lg': size === 'lg',
          'modal-xl': size === 'xl',
          'full-screen': fullScreen,
        })}
      >
        <Modal.Header closeButton>
          {!disableFullScreen && (
            <button
              type="button"
              className="toggle-full-screen"
              onClick={() => this.setState(state => ({ fullScreen: !state.fullScreen }))}
            >
              <i
                className={classNames('fa', {
                  'fa-compress': fullScreen,
                  'fa-expand': !fullScreen,
                })}
              />
            </button>
          )}
          <Modal.Title>
            {title}{' '}
            {zendeskArticle && <ZendeskHelp article={zendeskArticle} className="margin5L" />}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <div className="pull-left">{leftButton}</div>
          <Button
            onClick={onClose}
            disabled={disabled}
            btnClassName={okClassName}
            onMouseOver={() => onHoverSave()}
            onFocus={() => onHoverSave()}
            showProgress
            name="OkModal-Ok"
          >
            {okLabel || intl.formatMessage(messages.Ok)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(OkModal);
